<script lang="ts">

    import {contextService} from './services';

    export let id: string;

    async function getName() {
        return contextService.getContextName(id);
    }
</script>

{#await getName() then name}
    <span>{name}</span>
{/await}